import Dynaomic from './Dynamic';

export default Dynaomic;
